import { create } from "zustand";
import type { BrandListItem } from "src/api/brand/brandApi";

type BrandQuery = {
  brandName: string;
  categoryId: string; // UI 입력용 (숫자/빈값 처리 쉽게)
  isActive: "" | "true" | "false";
  isFeatured: "" | "true" | "false";
  page: number; // UI 1-based
  size: number;
  order: string;
};

type BrandStore = BrandQuery & {
  dialogOpen: boolean;
  editItem: BrandListItem | null;

  setQuery: (next: Partial<BrandQuery>) => void;

  openCreate: () => void;
  openEdit: (item: BrandListItem) => void;
  closeDialog: () => void;
};

export const useBrandStore = create<BrandStore>((set) => ({
  brandName: "",
  categoryId: "",
  isActive: "",
  isFeatured: "",
  page: 1,
  size: 20,
  order: "displayOrder,asc",

  dialogOpen: false,
  editItem: null,

  setQuery: (next) => set((prev) => ({ ...prev, ...next })),

  openCreate: () => set({ dialogOpen: true, editItem: null }),
  openEdit: (item) => set({ dialogOpen: true, editItem: item }),
  closeDialog: () => set({ dialogOpen: false, editItem: null }),
}));
